import { $authHost } from ".."

export const getFactoryLinesByFactoryIdAPI = async ({ factoryId }) => {
    let params = ''

    if (factoryId) {
        params = `?factoryId=${factoryId}`
    }

    const {data} = await $authHost.get(`api/factory_lines/get_factory_lines_all${params}`)
    return data
}